/** Component for collection functions */
export function collection(){
    var _THIS = this;
    this.elemContainer = null;


    this.colourGroupClasses  = [
      "background-color-linen-gray",
      "background-color-light-coral", 
      "background-color-warm-stone", 
      "background-color-pure-oak", 
      "background-color-natural-greige"
    ]



    this.init=function(elemcontainer){

        if(!$("body").hasClass("template-collection")){return;}
        
        updateFilterScroll(".collection-filter-section");
        
        checkFilters(".collection-filter-section",this.colourGroupClasses);
        registerEvents();
        initFilters();
        cleanTitleTags();

        (async () => {
            const { initPromoFlags, initPromoNames } = await import(theme.components.commonURL);

            initPromoFlags("#product-list .product-item-promo-flag");
            initPromoNames("#product-list .product-item-promo-name");

        })();
        
    }    



    var registerEvents  = function(){




        
        $(document).on("click",".collection-filters-toggle",function(e){
            
            $(".collection-wrapper").toggleClass("showfilters")

            if(!$(".collection-wrapper").hasClass("showfilters")){
                var scrollbalance = new ScrollBalance(document.querySelector('.scroller'));
                scrollbalance.teardown();
            }else{
                console.log("init scrollbanalnce")
                if(typeof(ScrollBalance)=='function'){
                    setTimeout(function(){
                       var sb = new ScrollBalance($('.scroller'),{
                           minwidth: 1024,
                           fixedElementHeight:$("#header-wrapper").length>0?($("#header-wrapper").height()+10):0 //10 extra padding
                       });
                       sb.bind();
                       sb.initialize();
                       $(window).trigger("resize")
                    },500)
                }
            }

            
        })


        $(document).on("click",".collection-filter-control a",function(e){
            e.preventDefault();
            $(".filter").toggleClass("hide");
            $(".collection-filter-control").toggleClass("active");

            if(!$(".model-viewer-selection").hasClass("hide")){
                (async () => {
                    const { default:models } = await import(theme.components.modelsURL);
                       
                        var getModelId = models.getModel()
                        $(".model-viewer-selection").addClass("hide")
    
                        if(getModelId=="0"){
                            $(".model-viewer .model-input-view").prop("checked",false).trigger("change")
                        }
                
                })();
            }
        })


        //on load we get the selected title
        
        if($(".sel-collection-sort option[selected=selected]")){
            var getSortText = $(".sel-collection-sort option[selected=selected]")[0]?.text
            if(getSortText){
                $(".collection-sort-control .selected-sort-by").text(getSortText)
                $(".collection-sort-control .sort-icon").attr("title",getSortText)
            }
            
        }
        
        $(document).on("change",".sel-collection-sort",function(e){
            if($(this).val()!==""){
                var newurl = setURLParameter(window.location.href,'sort_by', $(this).val());
                window.location.href = newurl
            }
        })

        $(".collection-sort-control").hover(
            function(e){
              
            },
            function(e){
                $(".collection-sort-control .sort-list").addClass("hide")
            }
          )

        $(document).on("click",".collection-sort-control .sort-icon",function(e){
            $(".collection-sort-control .sort-list").toggleClass("hide")
        })

        $(document).on("click",".collection-sort-control .sort-list li",function(e){

            var attribSort = $(this).attr("data-value");
            $(".collection-sort-control .sel-collection-sort").val(attribSort).trigger("change")
            var getSortText = $(".sel-collection-sort option[selected=selected]")[0].text
            $(".collection-sort-control .selected-sort-by").text(getSortText)
            $(".collection-sort-control .sort-icon").attr("title",getSortText)
            $(".collection-sort-control .sort-list").toggleClass("hide")
            
        })


        $(document).on("click","#filters-header .close-filter",function(e){
            $(".collection-wrapper").toggleClass("showfilters")
        })

        


        $(document).on("click",".collection-filters-apply",function(e){
            e.preventDefault();
            $(".filter").toggleClass("hide");
            $(".collection-filter-control").toggleClass("active");
        })


        $(document).on("keyup",".collection-filter-search-name input.search-input",function(e){
            e.preventDefault();
            searchFilter($(this),e);
        })


        $(document).on("click","a.collection-filter-title",function(e){
            e.preventDefault();
            setSelectedFilterSection($(this),e);
        })


        /*$(document).on("click",".collection-filters-headings a.collection-filter-title",function(e){
            e.preventDefault();
            $(".collection-filters-headings li").removeClass("mobile-show")
            $(this).parent().addClass("mobile-show")
            var targetedDiv = $(this).attr("data-filter-section");
            $("." + targetedDiv).find("a.collection-filter-title").trigger("click")
            
        })*/

            $(document).on("click","a.collection-filter-title",function(e){
                e.preventDefault();
                
                $(this).parent().closest(".wrap-content").toggleClass("collapse")
                
                
                
            })


    }

    var initFilters = function(){

        //The first filter will be preselected
        $(".collection-filter-section").eq(0).addClass("mobile-show")
        $(".collection-filters-headings li").eq(0).addClass("mobile-show")


        

    }
    var cleanTitleTags = function(){
        
        try{
            var searchLocale = "__" + (Shopify.locale==""?"en":Shopify.locale) + "__"

            $(".collection-filters .collection-filter-section").each(function(){
                var getCollectionHeading = $(this).find("h3").attr("data-heading-name");
                var getCollectionHeadingText = $(this).find("h3").attr("data-heading-original-name")

                $(this).find(".collection-filter-item").each(function(){
                    var searchString = $(this).attr("data-tag-original")
                    var currentTitle = $(this).find("a").attr("title")
                    var newTitle  = currentTitle.split("__").join(" ") 

                    if(searchString.indexOf(searchLocale)!==-1){
                        newTitle  = currentTitle.split(searchLocale).join(" ") 
                    }
                    
                    newTitle = newTitle.replace(getCollectionHeading,getCollectionHeadingText);

                    $(this).find("a").attr("title",newTitle)
                    
                })
            })

        }catch(err){

        }

    }

    var setSelectedFilterSection = function(element,e){
        //console.log(element)
        $(".collection-filter-section").removeClass("mobile-show");
        element.closest(".collection-filter-section").addClass("mobile-show")
        

        setTimeout(function(){
            $(window).trigger("resize")
        },200)

    }


    var updateFilterScroll = function(filtersection){
        $(filtersection).each(function(){
            if($(this).find(".collection-filter-item:not(.hide)").length > 6){
                $(this).addClass("scroll");
            }else{
                $(this).removeClass("scroll");
            }
        })
    }


    var checkFilters = function(filtersection,arrColourGroupClasses){

        var _THIS = this;
        var isAnyFilterSelected = false;
        var selectedFilterHTML = "";
        var countFilterIndex = 0;
        $(filtersection).each(function(){
            if($(this).find(".collection-filter-item.selected").length>0){
                isAnyFilterSelected = true;
                    var getSelectedTag = encodeURIComponent($(this).find(".collection-filter-item.selected").attr("data-tag-type"))
                    $(this).find(".collection-clear-filter").removeClass("hide")
                    $(this).find(".collection-clear-filter").find("a").attr("href",$(this).find(".collection-filter-item.selected").find("a").attr("href"))
                 
                    $(this).find(".collection-filter-item").each(function(){
                            var getHref = $(this).find("a").attr("href")
                            var nhref = getHref; 
                            
                            if (getHref.indexOf(getSelectedTag+"+")!==-1){
                                nhref =  getHref.replace(getSelectedTag+"+","")                                   
                            }else if(getHref.indexOf("+" + getSelectedTag)!==-1){
                                nhref =  getHref.replace("+" + getSelectedTag,"")                                   
                            }else if(getHref.indexOf(getSelectedTag)!==-1){
                                nhref =  getHref.replace( getSelectedTag,"")   
                            }
                            $(this).find("a").attr("href",nhref)

                            if($(this).hasClass("selected")){
                                selectedFilterHTML +="<a class='btn sm " + arrColourGroupClasses[countFilterIndex] + "' href='" +  $(this).find("a").attr("href")+ "'>"  + $(this).find("a").text() + "<span class='remove'></span></a>"
                                countFilterIndex ++
                                if(countFilterIndex > arrColourGroupClasses.length){
                                    countFilterIndex = 0
                                }
                            }

                    })
            }

            if(isAnyFilterSelected){
                //show the container divs here
                $(".selected-filters").html(selectedFilterHTML)
                $(".collection-selected-filters").removeClass("hide")
                $("#filters-footer").removeClass("hide")
            }else{
                $(".selected-filters").html("")
                $(".collection-selected-filters").addClass("hide")
                $("#filters-footer").addClass("hide")

            }
        })


    }

    var searchFilter = function(element,e){
        var searchText = element.val().toLowerCase();
        var searchItemsContainer = element.attr("data-search-element")
        var searchElements = $(searchItemsContainer).find(".collection-filter-item")

     
        var code = e.keyCode || e.which;
        if(code == 13) { 

        }else{

           if(searchText!==""){
                
                searchElements.addClass("hide")
                searchElements.each(function(){
                    var getTagValue = $(this).attr("data-tag-value").toLowerCase();
                    //console.log(getTagValue + "  " +  searchText)
                    if(getTagValue.indexOf(searchText)!==-1){
                        $(this).removeClass("hide")
                    }
                })
        
            }else{
                searchElements.removeClass("hide")
            }
        }

        updateFilterScroll(searchItemsContainer)
       

    }

    var setURLParameter  = function(url, key, value) {
            var key = encodeURIComponent(key),
                value = encodeURIComponent(value);
            var urlQueryString = '';
            var baseUrl = url.split('?')[0],
                newParam = key + '=' + value,
                params = '?' + newParam;
        
            if (url.split('?')[1] == undefined){ // if there are no query strings, make urlQueryString empty
                urlQueryString = '';
            } else {
                urlQueryString = '?' + url.split('?')[1];
            }
        
            // If the "search" string exists, then build params from it
            if (urlQueryString) {
                var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
                var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
        
                if (typeof value === 'undefined' || value === null || value === '') { 
                    params = urlQueryString.replace(removeRegex, "$1");
                    params = params.replace(/[&;]$/, "");
                    
                } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                    params = urlQueryString.replace(updateRegex, "$1" + newParam);
                    
                } else if (urlQueryString=='') { 
                    params = '?' + newParam;
                } else { // Otherwise, add it to end of query string
                    params = urlQueryString + '&' + newParam;
                }
            }
        
            // no parameter was set so we don't need the question mark
            params = params === '?' ? '' : params;
        
            return baseUrl + params;
        
    }
    
}

